module.exports = __webpack_public_path__ + "fb1a496821d420d902f06734183a01d4.webp";